import { render, staticRenderFns } from "./Tabbar.vue?vue&type=template&id=7f52be62&scoped=true"
import script from "./Tabbar.vue?vue&type=script&lang=js"
export * from "./Tabbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f52be62",
  null
  
)

export default component.exports